<template>
  <div>
    <transaction-tabs :type="type"></transaction-tabs>
    <v-card class="white rounded-lg">
      <v-card-title class="secondary--text">{{ title }}</v-card-title>
      <v-card-text>
        <m-datatable
            :headers="headers"
            :apiUrl="url"
            :filters.sync="filters"
            @dblclick:row="(e, row) => $router.push(to(row.item))"
            ref="datatable"
        >
          <template #item.settle="{ item }">
            <v-btn depressed class="rounded-lg" color="info white--text" :to="toSettle(item)" text>تسویه</v-btn>
          </template>
          <template #item.detail="{ item }">
            <detail-link :to="to(item)"/>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import TransactionTabs from "@/views/panel/transaction/TransactionTabs";

export default {
  name: "TransactionsList",
  components: {TransactionTabs},
  props: {
    type: {},
  },
  data() {
    return {
      filters: {},
      url: "reports/lists/transactions",
    };
  },
  computed: {
    title() {
      switch (this.type) {
        case "receive":
          return this.setDocumentTitle("لیست دریافت ها")
        case "payment":
          return this.setDocumentTitle( "لیست پرداخت ها")
        case "bankTransfer":
          return this.setDocumentTitle( "لیست پرداخت بین بانکی")
        case "imprest":
          return this.setDocumentTitle( "لیست پرداخت های تنخواه")
        case "paymentGuarantee":
          return this.setDocumentTitle( "اسناد ضمانتی پرداختنی")
        case "receivedGuarantee":
          return this.setDocumentTitle( "لیست اسناد ضمانتی دریافتنی")
      }
    },
    headers() {
      let headers = [
        {
          text: "شماره",
          value: "code",
          width: '100px'
        },
        {
          text: (this.type == "payment" || this.type == "paymentGuarantee" || this.type == "bankTransfer" || this.type == "imprest") ? 'پرداخت به' : 'دریافت از',
          value: "account.name",
          width: '200px',
        },
        {
          text: "تاریخ",
          value: "date",
          width: '150px',
          type: 'date',
        },
        {
          text: "شرح",
          value: "explanation",
          max_length: 500
        },
      ];

      let imprestHeaders = [
        {
          text: "مبلغ پرداختی",
          value: "sanad.bed",
          type: "numeric",
          width: '200px',
        },
        // {
        //   text: "تاریخ تسویه",
        //   value: "imprestSettlement.date",
        // },
        // {
        //   text: "مبلغ تسویه شده",
        //   value: "imprestSettlement.settled_value",
        //   type: "numeric",
        // },
        // {
        //   text: "مانده",
        //   value: "remain",
        //   type: "numeric",
        //   sortable: false,
        //   filterable: false,
        // },
        // {
        //   text: "تسویه",
        //   value: "settle",
        //   sortable: false,
        //   filterable: false,
        // },
      ];

      if (this.type == "imprest") {
        headers = headers.concat(imprestHeaders);
      } else {
        headers = headers.concat([
          {
            text: "مبلغ مجموع",
            value: "sanad.bed",
            type: "numeric",
            width: '200px',
          },
        ]);
      }

      headers.push({
        text: "جزئیات",
        value: "detail",
        sortable: false,
        width: '50px',
        filterable: false,
      });
      return headers;
    },
  },
  created() {
    this.filters.type = this.type;
  },
  watch: {
    $route() {
      this.$refs.datatable.getDataFromApi();
    },
  },
  methods: {
    to(item) {
      return {
        name: "TransactionForm",
        params: {
          type: item.type,
          id: item.id,
        },
      };

    },

    toSettle(item) {
      return {
        name: "ImprestSettlementForm",
        params: {
          id: item.id,
        },
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
